import { render, staticRenderFns } from "./edit-holiday.vue?vue&type=template&id=eb6bf6c6&"
import script from "./edit-holiday.vue?vue&type=script&lang=ts&"
export * from "./edit-holiday.vue?vue&type=script&lang=ts&"
import style0 from "./edit-holiday.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-holiday.vue"
export default component.exports